export default "__VITE_ASSET__D8d7S9iv__"